import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animale-exploatatie',
  templateUrl: './animale-exploatatie.component.html',
  styleUrls: ['./animale-exploatatie.component.scss']
})
export class AnimaleExploatatieComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
